/*
 * Layout constants shared across panels and overlays.
 *
 * Deliberately a leaf module with no imports: style modules like
 * `sidebar.style` and `custom-drawer.style` pull in `@animech/ui` components,
 * so anything that only needs these numbers (canvas overlays positioning
 * themselves relative to the sidebar, tree-nav menus sizing their drawers)
 * imports them from here instead of dragging a component library — and its
 * test mocks — into the module graph.
 */
/** Width of the left sidebar panel, and of the drawers that open from it. */
export var sidebarWidthPx = 322;
export var sidebarWidth = "".concat(sidebarWidthPx, "px");
export var sidebarPadding = "20px";
/** How long a sidebar drawer takes to slide open/closed. */
export var drawerTransitionDelay = 400; // ms
export var narrowDrawerWidth = 240;
/*
 * Stacking inside the canvas container. The floating badges/panels anchored to
 * scene objects (`CanvasOverlay`) sit above plain overlays; interactive canvas
 * controls (the pallet preset/layer column, the fill tool's panel) sit above
 * the badges, so a badge projected near a control never paints over it.
 */
export var canvasOverlayZIndex = 3;
export var canvasControlsZIndex = canvasOverlayZIndex + 1;
